function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("g", {
  transform: "matrix(1 0 0 -1 0 864)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M540 468v-396h-72v396h72zM567 612c0 -34 -29 -63 -63 -63s-63 29 -63 63s29 63 63 63s63 -29 63 -63zM936 360c0 238 -194 432 -432 432s-432 -194 -432 -432s194 -432 432 -432s432 194 432 432zM1008 360c0 -278 -226 -504 -504 -504s-504 226 -504 504 s226 504 504 504s504 -226 504 -504z"
}));

var SvgComponent = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    version: 1.1,
    viewBox: "0 0 1008 1008"
  }, props), _ref);
};

export default __webpack_public_path__ + "static/media/info-circle.b5960837.svg";
export { SvgComponent as ReactComponent };